import './style.scss'
import { useContext, useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { CustomContainer, FixedContainer, FlexColumn, GridContainer, Icon } from "src/style"
// import {ReactComponent as Logo} from 'src/assets/img/app-logo-black.svg'

export const AccountDeletionContainer: React.FC<any> = ({width, minHeight, children}) => {
    const navigate = useNavigate()
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [appLogo, setAppLogo] = useState('')

    useEffect(() => {
        if (institutionData) setAppLogo(institutionData.logo)
    }, [institutionData?.logo])
    
    return (
        <>
            <FixedContainer top="0" left="0" width="100" sizeUnit="%" zIndex="2">
                <FlexColumn 
                    height="7.3" alignItems="flex-start" bgColor="#ffffff"
                    leftPadding="5" rightPadding="2"
                >
                    <CustomContainer 
                        width='15' height='4'
                        onClick={() => navigate('/login')}
                    >
                        { appLogo ? <Icon src={appLogo} className='app-logo-icon' /> : null }
                    </CustomContainer>
                    {/* <Logo className='icon-component header-logo' /> */}
                </FlexColumn>
            </FixedContainer>
            <GridContainer 
                height="100" hUnit="%" padding='2.5'
                bgColor='rgba(0, 0, 0, 0.05)' topPadding="9.8"
                style={{overflow: 'hidden'}}
            >
                <CustomContainer
                    padding="2" width={width || '49'} radius='2'
                    minHeight={minHeight || '30.5'} bgColor='#ffffff'
                    className="acct-deletion-box"
                >
                    {children}
                </CustomContainer>
            </GridContainer>
        </>
    )
}
